import React from 'react'
import { Dialog } from '@leverege/ui-elements'

export default function OwnedPermissionsWarning( props ) {
  const { attribute, blueprint, onOkay, onClose, ...rest } = props
  const message = `This will cause any child 
  device to be permanently deleted when removed from its parent ${blueprint.alias || blueprint.id}. 
  All users with permissions to delete the ${attribute.name} relationship on 
  ${blueprint.alias || blueprint.id} will therefore be able to delete ${attribute.name} devices.`

  const nOnOkay = () => {
    onOkay()
    onClose()
  }

  return (
    <Dialog.Question
      {...rest}
      variant="dialogMedium"
      title={`Delete ${attribute.name} on removal from ${blueprint.alias || blueprint.id}?`}
      message={message}
      onOkay={nOnOkay}
      onCancel={onClose}
      okay="Yes, delete when removing"
      okayVariant="primaryDestructive" />
  )
}
